if (isAuctionsEnabled()) {
  function refreshAuctions(cb) {
    clearAllExistingTimers();
    window.auctionItem = [];
    initAuctionsMinimumBid();
    checkLeadingAuctionsInfo();
    loadAuctionBidTimer();

    if (typeof cb === 'function') {
      cb();
    }
  }

  function clearAllExistingTimers() {
    if (window.hasOwnProperty('auctionItem')) {
      for (var item of window.auctionItem) {
        clearInterval(item.timer);
      }
    }
  }

  function initAuctionsMinimumBid() {
    $('.product-auction').each(function(idx, el) {
      var $auctionEl = $(el);
      if (isMyAccount($auctionEl.data('latest-bidder-account-id'), $auctionEl.data('latest-autobidder-account-id'))) {
        $auctionEl.find('input.bid').val('');
      } else {
        $auctionEl.find('input.bid').val(Number($auctionEl.data('minimum-bid')));
      }
    });
  }

  function checkLeadingAuctionsInfo($specificAuctionEl) {
    if ($specificAuctionEl) {
      var $auctionEl = getAuctionElement($($specificAuctionEl).data('id'));
      checkLeadingAuctionItem($specificAuctionEl);
    } else {
      $('.product-auction').each(function(idx, el) {
        var $auctionEl = getAuctionElement($(el).data('id'));
        checkLeadingAuctionItem($auctionEl);
      });
    }

    function checkLeadingAuctionItem($auctionEl) {
      var $auctionEl = getAuctionElement($($auctionEl).data('id'));
      if ($auctionEl.find('.price-text').length > 0) {
        if ($auctionEl.data('bids') > 0) {
          $auctionEl.find('.bid-count').removeClass('no-bid');
        }

        if (isLoggedIn() && isMyAccount($auctionEl.data('latest-bidder-account-id'), $auctionEl.data('latest-autobidder-account-id'))) {
          changeAuctionMyAccountLeadingBid($auctionEl);
        } else {
          changeAuctionToOtherAccountLeadingBid($auctionEl);
        }
      }
    }

    function changeAuctionMyAccountLeadingBid($auctionEl) {
      var $auctionEl = getAuctionElement($($auctionEl).data('id'));
      if ($auctionEl.data('endDate') > $auctionEl.data('systemTime')) {
        $auctionEl.find('.price-text').html('My Leading Bid');
      }
      $auctionEl.addClass('my-leading');

      $auctionEl.find('.bid').addClass('hide');
      $auctionEl.find('.btn-place-bid').addClass('btn-edit-bid');

      if ($auctionEl.data('autobid')) {
        $auctionEl.find('.btn-place-bid').addClass('btn-edit-autobid');
        $auctionEl.find('.price-text-hint').html('Active Autobid up to ' + $auctionEl.data('maximum-autobid-price'));
      } else {
        $auctionEl.find('.btn-place-bid').removeClass('btn-edit-autobid');
        $auctionEl.find('.price-text-hint').html('Place a bid of ' + $auctionEl.data('minimum-bid-price') + ' or more');
      }

      $auctionEl.find('.btn-place-bid').html('Edit Bid');
      $auctionEl.find('.btn-place-bid').addClass('btn-common-radius');
    }

    function changeAuctionToOtherAccountLeadingBid($auctionEl) {
      if ($auctionEl.data('bids') > 0) {
        if ($auctionEl.hasClass('change-leading')) {
          if (isMobile) {
            $auctionEl.find('.price-text').html('New Bid - Account #' + $auctionEl.data('latest-bidder-account-id') + '<br>');
          } else {
            $auctionEl.find('.price-text').html('New Bid - Account #' + $auctionEl.data('latest-bidder-account-id'));
          }
        } else {
          if ($auctionEl.data('endDate') > $auctionEl.data('systemTime')) {
            $auctionEl.find('.price-text').html('Leading Bid');
          } else {
            $auctionEl.find('.price-text').html('Final Price');
          }
        }
      } else {
        $auctionEl.find('.price-text').html('Starting Price');
      }

      $auctionEl.removeClass('my-leading');
      $auctionEl.find('.bid').removeClass('hide');
      $auctionEl.find('.btn-place-bid').removeClass('btn-edit-bid');
      $auctionEl.find('.btn-place-bid').removeClass('btn-edit-autobid');
      $auctionEl.find('.price-text-hint').html('Place a bid of ' + $auctionEl.data('minimum-bid-price') + ' or more');
      $auctionEl.find('.btn-place-bid').html('Place Bid');
      $auctionEl.find('.btn-place-bid').removeClass('btn-common-radius');
    }
  }

  var ONE_SECOND = 1000;

  function loadAuctionBidTimer() {
    $('.product-auction').each(function(idx, el) {
      var $auctionEl = $(el);
      var endDate = $auctionEl.data('end-date');
      // if (!endDate) {
      // console.log('Auction element with no end-date, auction id : ' + $auctionEl.data('id'));
      // check why there's a phantom auction element with no end-date
      // return;
      // }

      var systemTime = $auctionEl.data('system-time');
      var timeDiff = endDate - systemTime;
      var runningLeftInSeconds = timeDiff / ONE_SECOND;
      if (runningLeftInSeconds >= 0) {
        initBidTimer($auctionEl);
      } else {
        auctionEnded($auctionEl.data('id'))
      }
    });

    function initBidTimer($auctionEl) {
      var auctionId = $auctionEl.data('id');
      updateAuctionTime(auctionId);

      /**
       * Commented the code below to stop the timer interval once the auction item has been expired
       * Todo: remove in future after few tests
       */
      // window.auctionItem['auction-' + auctionId] = {
      //   timer: createAuctionBidTimer(auctionId)
      // };
    }
  }

  function createAuctionBidTimer(auctionId) {
    var $auctionEl = getAuctionElement(auctionId);
    return setInterval(function() {
      updateAuctionTime(auctionId);
    }, ONE_SECOND);
  }

  function updateAuctionTime(auctionId) {
    var $auctionEl = getAuctionElement(auctionId);
    if (!$auctionEl.length > 0) {
      return;
    }

    var auctionItem = window.auctionItem.find(item => item.id === auctionId);
    if (!auctionItem) {
      var timerId = createAuctionBidTimer(auctionId);
      var auctionItem = {
        id: auctionId,
        timer: timerId
      };
      window.auctionItem.push(auctionItem);
    }

    /**
     * Commented the code below to stop the timer interval once the auction item has been expired
     * Todo: remove in future after few tests
     */
    // auctionItem = auctionItem ? auctionItem : {timer: createAuctionBidTimer(auctionId)};

    var endDate = $auctionEl.data('end-date');
    var systemTime = $auctionEl.data('system-time');
    if (!systemTime) {
      return;
    }
    $auctionEl.data('system-time', systemTime + ONE_SECOND);
    var timeLeft = endDate;
    // var timeNow = new Date().getTime();
    var timeDiff = timeLeft - systemTime;
    var runningLeftInSeconds = timeDiff / ONE_SECOND;
    var timerEl = $auctionEl.find('.time');
    var $endsEl = $auctionEl.find('.ends');

    if (runningLeftInSeconds >= 0) {
      var leftInHourMinuteSecond = timeDiffInHoursMinutesSeconds(runningLeftInSeconds);

      if (runningLeftInSeconds < (60 * 60 * 24)) {
        $auctionEl.find('.time-left').addClass('lessThan24hrs');
        if (runningLeftInSeconds < (60 * 15)) {
          $auctionEl.find('.time-left').addClass('lessThan15min');
        }
      }
      with(leftInHourMinuteSecond) {
        timerEl.html(hours + ':' + minutes + ':' + seconds);
        $endsEl.html('Ends ' + (moment(new Date(endDate)).format('DD MMM HH:mm')));
      }
      // runningLeftInSeconds--;
      checkLeadingAuctionsInfo($auctionEl);
    } else {
      clearInterval(auctionItem.timer);

      // Check if the user won. Execute only if auction just ended.
      var $auctionEl = getAuctionElement(auctionId);
      if (!$auctionEl.hasClass('ended') && !$auctionEl.hasClass('winner')) {
        setTimeout(function() {
          auctionModule.getAuction(auctionId, function(res) {
            var auction = res.auction;

            if ((auction.bids > 0 && auction.winnerAccountId > 0) ||
              (auction.bids == 0 && auction.winnerAccountId == 0)
            ) {
              auctionEnded(auctionId);

              if (isMyAccount(auction.winnerAccountId)) {
                auctionWon(auctionId);
              }
            } else {
              auctionModule.refreshAuctionItem(auction);
              refreshAuctions();
            }
          });
        }, 3000);
      } else {
        auctionEnded(auctionId);
      }
    }

    updateAuctionWatchlistInfo(auctionId);
  }

  function auctionEnded(auctionId) {
    var $auctionEl = getAuctionElement(auctionId);
    var timeLeftEl = $auctionEl.find('.time-left');
    var timerEl = $auctionEl.find('.time');
    var endDate = $auctionEl.data('end-date');
    var latestBidderAccountId = $auctionEl.data('latest-bidder-account-id');
    var latestAutoBidderAccountId = $auctionEl.data('latest-autobidder-account-id');
    var hasBids = $auctionEl.data('bids') && $auctionEl.data('bids') > 0 ? true : false;

    var EMPTY_VALUE = '&nbsp;';
    var INVISIBLE_CLASS = 'invisible';
    var HIDE_CLASS = 'hide';

    $auctionEl.addClass('ended');
    $auctionEl.find('.bell').hide();
    $auctionEl.find('.ends').html(EMPTY_VALUE);
    $auctionEl.find('.price-text-hint').html(EMPTY_VALUE);
    $auctionEl.find('.autobid-reached').addClass(INVISIBLE_CLASS);
    timerEl.html(moment(new Date(endDate)).format(auctionEndTimeFormat($auctionEl)));
    timeLeftEl.removeClass('lessThan24hrs lessThan15min');

    if ($auctionEl.hasClass('wide') || $auctionEl.find('.wrap-item').hasClass('wide')) {
      // timeLeftEl.html(timeLeftEl.html().replace(/time left/gi, 'ended'));
      // timeLeftEl.find('.narrow').css('text-transform', 'capitalize');

      $auctionEl.each(function(i) {
        var timeLeftElem = $(this).find('.time-left');
        if ($(this).hasClass('.wide')) {
          timeLeftElem.html(timeLeftElem.html().replace(/time left/gi, 'ended'));
          timeLeftElem.find('.narrow').css('text-transform', 'capitalize');
        } else {
          timeLeftElem.html(timeLeftElem.html().replace(/time left/gi, 'Ended'));
        }
      });
    } else {
      timeLeftEl.html(timeLeftEl.html().replace(/time left/gi, 'Ended'));
    }

    if ($auctionEl.data('bids') > 0) {
      $auctionEl.find('.price-text').html(isMyAccount(latestBidderAccountId, latestAutoBidderAccountId) ? 'My Winning Bid' : 'Final Price');
      $auctionEl.find('.btn-place-bid').off('click');
      $auctionEl.find('.btn-place-bid').addClass('btn-view-bids');
      $auctionEl.find('.btn-place-bid').html('View Bids');
    } else {
      $auctionEl.find('.btn-place-bid').hide();
      $auctionEl.find('.actions').hide();
      $auctionEl.find('.price-text-hint').hide();

      $auctionEl.find('.btn-view-bids').hide();
      $auctionEl.find('.order-field').hide();
    }


    $auctionEl.find('.bid').hide();
    $auctionEl.find('.order-field').addClass('ended');
    $auctionEl.find('.btn-view-bids').removeClass('btn-place-bid btn-edit-bid btn-edit-autobid').addClass('btn-common-radius').addClass(hasBids ? '' : 'no-bid');

    $auctionEl.find('.btn-add-to-cart').addClass(INVISIBLE_CLASS).addClass(HIDE_CLASS);
    $auctionEl.find('.btn-buy-now').addClass(INVISIBLE_CLASS).addClass(HIDE_CLASS);
  }

  function auctionWon(auctionId) {
    var $auctionEl = getAuctionElement(auctionId);
    $auctionEl.addClass('winner');
  }

  function updateAuctionWatchlistInfo(auctionId) {
    recheckAuctionWatchlist();
    var watchlistedAuctionIds = localStorage.getItem('watchlisted-auction-ids') && localStorage.getItem('watchlisted-auction-ids').length > 0 ? JSON.parse(localStorage.getItem('watchlisted-auction-ids')) : [];
    var $auctionEl = getAuctionElement(auctionId);
    var isWatchlisted = watchlistedAuctionIds.indexOf(auctionId) > -1;
    var $auctionBell = $auctionEl.find('.bell');
    var prevSrc = $auctionBell.find('img').prop('src');

    if (isWatchlisted) {
      if (prevSrc) {
        $auctionBell.find('img').prop('src', prevSrc.replace('bell-gray', 'bell-orange'));
      }
      $auctionBell.removeClass('watchlist');
      $auctionBell.addClass('watchlisted');
    } else {
      if (prevSrc) {
        $auctionBell.find('img').prop('src', prevSrc.replace('bell-orange', 'bell-gray'));
      }
      $auctionBell.removeClass('watchlisted');
      $auctionBell.addClass('watchlist');
    }
  }

  function isMyAccount(latestBidderAccountId, latestAutoBidderAccountId) {
    var accountId = getAccountId();
    if (latestAutoBidderAccountId && latestAutoBidderAccountId > 0) {
      return accountId > 0 && accountId == latestAutoBidderAccountId;
    }

    return accountId > 0 && accountId == latestBidderAccountId;
  }

  function getAuctionElement(auctionId) {
    return $('.product-auction[data-id=' + auctionId + ']');
  }

  function checkAuctionElement(selector, cb) {
    var CHECK_MS = 100;
    var MAX_CHECK = (10 * 1000) / CHECK_MS;
    var iteration = 1;
    var auctionElementInterval = setInterval(function() {
      if ($(selector) && $(selector).length > 0) {
        clearInterval(auctionElementInterval);
        cb();
      } else {
        iteration++;
        if (iteration == MAX_CHECK) {
          clearInterval(auctionElementInterval);
        }
      }
    }, CHECK_MS);
  }

  function recheckAuctionWatchlist() {
    if (isLoggedIn()) {
      if (undefined == localStorage.getItem('watchlisted-auction-ids')) {
        localStorage.setItem('watchlisted-auction-ids', JSON.stringify([]));
        auctionModule.loadWatchlist();
      }
    } else {
      localStorage.removeItem('watchlisted-auction-ids');
    }
  }

  function alertWatchlistedAuctionDontShow(stop) {
    var key = 'stopAlertWatchlistedAuctionDontShow';
    if (stop) {
      localStorage.setItem(key, JSON.stringify(true));
    }

    return !(localStorage.getItem(key) && JSON.parse(localStorage.getItem(key)));
  }

  function defaultAccountAuctionsFilter() {
    var filter = {
      defaultSelectedFilter: ['active', 'all-metals', 'gold', 'silver', 'platinum', 'all-types', 'bars', 'coins', 'jewellery']
    };
    // if (isMyAccountAuctionsPage()) {
    //   filter.defaultSelectedFilter.unshift('saved');
    //   filter.defaultSelectedFilter.unshift('bid-entered');
    //   filter.defaultSelectedFilter.unshift('all-watchlist');
    // }
    return filter;
  }

  function getActiveAuctionsData() {
    var activeAuctionIds = [];
    $('.product-auction').each(function(i, auctionElement) {
      if (typeof $(auctionElement).data('id') !== 'undefined')
        activeAuctionIds.push($(auctionElement).data('id'));
    });
    if (activeAuctionIds.length) {
      auctionModule.getAuctions(
        activeAuctionIds.join(','),
        function(res) {
          if (res?.items && res.items.length) {
            for (var ctr = 0; ctr < res.items.length; ctr++) {
              auctionModule.refreshAuctionItem(res.items[ctr]);
            }
          }
          refreshAuctions();
        });
    }
  };

  function getAuctionCurrency() {
    return 'SGD';
  }

  checkAuctionElement('.product-auction[data-id]', function() {
    !window.auctionItem && refreshAuctions();
  });
}

function isAuctionsEnabled() {
  return (flagAuctionsEnabled == true && getLocation() == 1);
}

function getAuctionTimeLeft(currentTime, endDate) {
  var timeDiff = endDate - currentTime;
  var runningLeftInSeconds = timeDiff / ONE_SECOND;
  var leftInHourMinuteSecond = timeDiffInHoursMinutesSeconds(runningLeftInSeconds);
  with(leftInHourMinuteSecond) {
    return hours + ':' + minutes + ':' + seconds;
  }
}